import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

// Detail pages name themselves for the mobile top bar, which shows the name
// once the page header has scrolled away.
const TitleContext = createContext<{ title: string; setTitle: (t: string) => void }>({
  title: '',
  setTitle: () => {},
})

export function TitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState('')
  return <TitleContext.Provider value={{ title, setTitle }}>{children}</TitleContext.Provider>
}

export function usePageTitle(title: string | undefined) {
  const { setTitle } = useContext(TitleContext)
  useEffect(() => {
    setTitle(title ?? '')
    document.title = title ? `${title} · PodcastAlpha` : 'PodcastAlpha'
    return () => setTitle('')
  }, [title, setTitle])
}

export function useTitle() {
  return useContext(TitleContext).title
}
